export enum TableColumnTypeEnum {
  /**
   * Display the activation state with icon based on boolean
   */
  ACTIVE = 'active',

  /**
   * Display the column value on 2 lines as date and time based on the user profile timezone.
   */
  DATE = 'date',

  /**
   * Display the column value using a chip list.
   */
  LABEL = 'label',

  /**
   * Display a link with a text, function for onClick action, and param for the function
   */
  LINK = 'link',

  /**
   * Display a list of links, one by line, max two of them, if more than 2, a link is displayed to show all the list in a popover.
   */
  LINK_LIST = 'link-list',

  /**
   * Display a list of strings, one by line, max two of them, if more than 2, a link is displayed to show all the list in a popover.
   */
  LIST = 'list',

  /**
   * Display the column value using the app-site-icon-and-name
   */
  SITE = 'site',

  /**
   * Display the column value in bold
   */
  STRONG = 'strong',

  /**
   * Display a templateRef for complex display
   */
  TEMPLATE_REF = 'template-ref',
}
